import { Subscription } from 'rxjs';
// Angular
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
// Layout
import { LayoutConfigService, SplashScreenService, TranslationService } from './core/_base/layout';
// language list
import { locale as enLang } from './core/_config/i18n/en';
import { locale as chLang } from './core/_config/i18n/ch';
import { locale as esLang } from './core/_config/i18n/es';
import { locale as jpLang } from './core/_config/i18n/jp';
import { locale as deLang } from './core/_config/i18n/de';
import { locale as frLang } from './core/_config/i18n/fr';
import { CompanyService } from './core/auth/_services/company.service';
import { filter, map, take } from 'rxjs/operators';
import { ThemeService } from './core/auth/_services/theme.service';
import _ from 'lodash';

@Component({
	// tslint:disable-next-line:component-selector
	selector: 'body[kt-root]',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, OnDestroy {
	// Public properties
	title = 'CONTROLIR4 | IIOT 4.0';
	loader: boolean;
	private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
	selectedTheme = null;

	/**
	 * Component constructor
	 *
	 * @param translationService: TranslationService
	 * @param router: Router
	 * @param layoutConfigService: LayoutCongifService
	 * @param splashScreenService: SplashScreenService
	 */
	constructor(private translationService: TranslationService,
				         private router: Router,
				         private layoutConfigService: LayoutConfigService,
				         private splashScreenService: SplashScreenService,
						 private cdr: ChangeDetectorRef,
						 private themeService: ThemeService,
						 private companyService: CompanyService) {

		// register translations
		//this.translationService.loadTranslations(enLang, chLang, esLang, jpLang, deLang, frLang);
		this.translationService.loadTranslations(esLang ,  enLang, chLang,jpLang, deLang, frLang);
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		// enable/disable loader
		this.loader = this.layoutConfigService.getConfig('loader.enabled');

		const routerSubscription = this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				// hide splash screen
				this.splashScreenService.hide();

				// scroll to top on every route change
				window.scrollTo(0, 0);

				// to display back the body content
				setTimeout(() => {
					document.body.classList.add('kt-page--loaded');
				}, 500);
			}
		});

		this.unsubscribe.push(
			this.companyService.companyLoaded$.pipe(
				filter(loaded=>loaded==true),
				map(()=>this.companyService.getCurrentCompany())
			).subscribe((company)=>{
				//console.log("app component company: ");console.dir(company);
				let theme;
				if(company.theme_name)
					theme = this.themeService.getTheme(company.theme_name);
				else
					theme = this.themeService.getDefaultTheme();
				this.selectedTheme = theme.getCssVarObj();
				//console.log("selected theme: ");console.dir(this.selectedTheme);
				this.themeService.setCurrentTheme(theme);
				this.cdr.detectChanges();
			})
		)
		this.unsubscribe.push(routerSubscription);

		// // --- Configuración de la prueba ---
		// // Fecha de hoy (jueves, 26 de junio de 2025) a las 5 AM
		// // Nota: El mes es 0-indexado, así que junio es 5.
		// const testDate = new Date(2025, 5, 26, 5, 0, 0); // 26 de junio de 2025, 05:00:00
		// // Turno 1: Lunes a Viernes de 8 AM a 5 PM (17:00)
		// const shift1 = {
		// 	start_time_day: 'lun',
		// 	end_time_day: 'vie',
		// 	start_time_hour: 8,
		// 	start_time_minute: 0,
		// 	end_time_hour: 17,
		// 	end_time_minute: 0
		// };
		// // Turno 2: Lunes a Viernes de 5 PM (17:00) a 3 AM (03:00) (cruza la medianoche)
		// const shift2 = {
		// 	start_time_day: 'lun',
		// 	end_time_day: 'vie',
		// 	start_time_hour: 17,
		// 	start_time_minute: 0,
		// 	end_time_hour: 3,
		// 	end_time_minute: 0
		// };
		// // --- Ejecución de las pruebas ---
		// console.log(`ttest Fecha de prueba: ${testDate.toLocaleString()}`);
		// console.log('--------------------------------------------------');
		// // Prueba con el Turno 1
		// console.log('ttest Probando con Turno 1 (Lun-Vie 08:00-17:00):');
		// const result1 = inShiftBounds(shift1, testDate);
		// console.log(`ttest ¿Está la fecha en el Turno 1? ${result1}`); // Esperado: false (5 AM no está entre 8 AM y 5 PM)
		// console.log('ttest --------------------------------------------------');
		// // Prueba con el Turno 2
		// console.log('ttest Probando con Turno 2 (Lun-Vie 17:00-03:00):');
		// const result2 = inShiftBounds(shift2, testDate);
		// console.log(`ttest¿Está la fecha en el Turno 2? ${result2}`); // Esperado: true (5 AM del jueves está dentro del turno que empezó el miércoles a las 17:00 y termina el jueves a las 03:00)
		// console.log('ttest --------------------------------------------------');

		// const testDateSaturday = new Date(2025, 5, 28, 18, 0, 0); // 28 de junio de 2025, 05:00:00 (Sábado)
        
        //  // Turno 1: Lunes a Viernes de 8 AM a 5 PM (17:00)
        //  const shift1 = {
        //      start_time_day: 'lun',
        //      end_time_day: 'vie',
        //      start_time_hour: 8,
        //      start_time_minute: 0,
        //      end_time_hour: 17,
        //      end_time_minute: 0
        //  };
        
        //  // Turno 2: Lunes a Viernes de 5 PM (17:00) a 3 AM (03:00) (cruza la medianoche)
        //  const shift2 = {
        //      start_time_day: 'lun',
        //      end_time_day: 'vie',
        //      start_time_hour: 17,
        //      start_time_minute: 0,
        //      end_time_hour: 3,
        //      end_time_minute: 0
        //  };
        
        //  // --- Ejecución de las pruebas ---
        
        //  console.log(`xtest Fecha de prueba: ${testDateSaturday.toLocaleString()} (Sábado)`);
        //  console.log('xtest --------------------------------------------------');
        
        //  // Prueba con el Turno 1
        //  console.log('xtest Probando con Turno 1 (Lun-Vie 08:00-17:00):');
        //  const result1Saturday = inShiftBounds(shift1, testDateSaturday);
        //  console.log(`xtest ¿Está la fecha en el Turno 1? ${result1Saturday}`); // Esperado: false (Sábado no está en el rango Lun-Vie)
        //  console.log('xtest --------------------------------------------------');
        
        //  // Prueba con el Turno 2
        //  console.log('xtest Probando con Turno 2 (Lun-Vie 17:00-03:00):');
        //  const result2Saturday = inShiftBounds(shift2, testDateSaturday);
        //  console.log(`xtest ¿Está la fecha en el Turno 2? ${result2Saturday}`); // Esperado: false (Sábado no está en el rango Lun-Vie)
        //  console.log('xtest --------------------------------------------------');
	}

	/**
	 * On Destroy
	 */
	ngOnDestroy() {
		this.unsubscribe.forEach(sb => sb.unsubscribe());
	}
}
